export default __webpack_public_path__ + "static/media/CasualCollege.9936a70a.jpg";